export enum UserRoleType {

  ADMIN                 = 'admin',
  MANAGER               = 'manager',
  ERGONOMIST            = 'ergonomist',
  EMPLOYEE              = 'employee',

}
